export default __webpack_public_path__ + "static/media/foodERP_logo.af2ace89.png";